// `navigator.clipboard` exists only in secure contexts (HTTPS, localhost):
// elsewhere the text is copied from a hidden textarea.
function copyWithTextarea(text) {
  const { activeElement } = document;
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  try {
    return document.execCommand('copy');
  } finally {
    document.body.removeChild(textarea);
    // Selecting the textarea moved the focus away from the copy control.
    if (activeElement) activeElement.focus();
  }
}

// Resolves to whether the text reached the clipboard; never rejects.
export async function copyText(text) {
  try {
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    return copyWithTextarea(text);
  } catch (error) {
    return false;
  }
}
